import { render, staticRenderFns } from "./CookiePolicyBanner.vue?vue&type=template&id=6662ec4a&"
import script from "./CookiePolicyBanner.vue?vue&type=script&lang=ts&"
export * from "./CookiePolicyBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports